<template>
  <div>
    <b-navbar toggleable="lg" type="light" variant="defualt">

        <router-link  to="#" class="brand-main">
      <img
        id="logo-desk"
        src="../../assets/logo.jpg"
        alt="Movil Euros"
        class="d-none d-md-inline"
      >
      <img
        id="logo-mobile"
        src="../../assets/logo.jpg"
        alt="Laraspace Logo"
        class="d-md-none"
      >
    </router-link>


      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>


        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto textbold">

         
          <b-nav-item
           

          v-if="!isLogin"></b-nav-item>
          <b-nav-item-dropdown   right v-if="isLogin">
            <!-- Using 'button-content' slot -->
            <template slot="button-content">

              <em>{{ name }}</em>
            </template>
             <b-dropdown-item class="dropdown"  @click="logout">{{$t('log_out')}}</b-dropdown-item>
           </b-nav-item-dropdown>


        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
     <b-modal
      v-model="isShowInfo"
      ref="simple_show_info"
      id="simple_show_info"
      :title="$t('info')"
      ok-only
    >
      <p>{{ message }}</p>
    </b-modal>
  </div>
  
</template>

<script>

import Auth from "../../services/auth";
import {Role} from '.././../helpers/role'
export default {

    
     props: {
    statusAction: {
      type: Object,
      require: true,
      default: Object
    }
  },
  data() {
    return {
      isLogin: Auth.isLogin(),
      name:'',
      homeRedirectPath:'',
      role:'',
      message: "",
      isShowInfo: false,
    };
  },

  created() {
    if (this.isLogin) {
      const currentUser= Auth.userData();
      this.name=currentUser.user.name;
      this.role=currentUser.user.role;
      //this.renderHomePath();
    }
  },

watch: {
    getFullPath() {
     
    },
    statusAction: function(newVal) {
      setTimeout(() => {
        console.log(JSON.stringify(newVal));

        if (newVal.errorCode == "11") {
          this.message = newVal.message;
          this.isShowInfo = true;
        }
      }, 500);
    }
  },

  methods: {
    renderHomePath() {
        this.isAssistant=(this.role == Role.AgentAssistant.Profile);
    },
    logout () {


      Auth.logout().then(() => {
        this.$router.replace(this.$i18nRoute({ name: 'login'}));
      })
    }
  }
};

</script>

<style scoped>

.dropdown{

 color: #fff !important;

}
</style>



